module.exports = __webpack_public_path__ + "res/logo.7f185892bc84708e67f6cc6da43996f0.png";